export const acquisitionRouter = [
    {
        path: 'acquisition/list',
        name: 'acquisition list',
        component: () => import('./pages/list')
    },
    {
        path: '/acquisitions/detail/:id',
        name: 'acquisition detail',
        component: () => import('./pages/detail_acquisition')
    }


]